import { API_LIMIT_DATA } from '../utils/constants';
import { Axios } from './Axios';

export async function createFeed(data) {
  const url = `post`;
  return Axios({
    url,
    method: 'post',
    data
  });
}

export async function getAllFeedsByOrg(orgId, offset = 0, limit = API_LIMIT_DATA) {
  const url = `post?orgId=${orgId}&limit=${limit}&page=${offset}&populate=createdBy`;
  return Axios({
    url,
    method: 'get'
  });
}

export async function getAllFeedsByCreator(userId, offset = 0, limit = API_LIMIT_DATA) {
  const url = `post?createdBy=${userId}&limit=${limit}&page=${offset}&populate=createdBy`;
  return Axios({
    url,
    method: 'get'
  });
}

export async function likeFeed(feedId, userId) {
  const url = `post/${feedId}/like?userId=${userId}`;
  return Axios({
    url,
    method: 'patch'
  });
}

export async function dislikeFeed(feedId, userId) {
  const url = `post/${feedId}/dislike?userId=${userId}`;
  return Axios({
    url,
    method: 'patch'
  });
}

export async function deleteFeed(feedId) {
  const url = `post/${feedId}`;
  return Axios({
    url,
    method: 'delete'
  });
}

export async function giveAnsToPoll(postId, userId, optionId) {
  const url = `post/${postId}/poll?userId=${userId}&optionId=${optionId}`;
  return Axios({
    url,
    method: 'patch'
  });
}

export async function ansMCQ(postId, userId, optionId) {
  const url = `post/${postId}/mcq?userId=${userId}&optionId=${optionId}`;
  return Axios({
    url,
    method: 'patch'
  });
}

export async function getLikeDetails(postId) {
  const url = `post/${postId}/like/details`;
  return Axios({
    url,
    method: 'get'
  });
}
